import request from '@/utils/request'

// 查询手环列表
export function listWristband(query) {
  return request({
    url: '/system/wristband/list',
    method: 'get',
    params: query,
  })
}

// 查询手环分页
export function pageWristband(query) {
  return request({
    url: '/system/wristband/page',
    method: 'get',
    params: query,
  })
}

// 查询手环详细
export function getWristband(data) {
  return request({
    url: '/system/wristband/detail',
    method: 'get',
    params: data,
  })
}

// 新增手环
export function addWristband(data) {
  return request({
    url: '/system/wristband/add',
    method: 'post',
    data: data,
  })
}

// 修改手环
export function updateWristband(data) {
  return request({
    url: '/system/wristband/edit',
    method: 'post',
    data: data,
  })
}

// 删除手环
export function delWristband(data) {
  return request({
    url: '/system/wristband/delete',
    method: 'post',
    data: data,
  })
}

// 导入手环数据
export function importWristbandData(data) {
  return request({
    url: '/system/wristband/importData',
    method: 'post',
    data: data,
  })
}

// 导入手环工作流数据
export function importWristbandWorkflowData(data) {
  return request({
    url: '/system/wristband/importWorkflowData',
    method: 'post',
    data: data,
  })
}

// 修改手环状态
export function changeWristbandStatus(data) {
  return request({
    url: '/system/wristband/editStatus',
    method: 'post',
    data: data,
  })
}

// 分页查询考勤员工列表
export function pageWristbandEmployees(query) {
  return request({
    url: '/system/wristband/employee/page',
    method: 'get',
    params: query,
  })
}

// 查询备品更换可选手环列表
export function listSpareReplacementOptions(query) {
  return request({
    url: '/system/wristband/spareReplacement/options',
    method: 'get',
    params: query,
  })
}

// 手环备品更换
export function spareReplacement(data) {
  return request({
    url: '/system/wristband/spareReplacement',
    method: 'post',
    data,
  })
}

// 手环岗位互换
export function positionSwap(data) {
  return request({
    url: '/system/wristband/positionSwap',
    method: 'post',
    data,
  })
}

// 手环工作流转换
export function convertWorkflowType(data) {
  return request({
    url: '/system/wristband/convertWorkflowType',
    method: 'post',
    data,
  })
}